function numberWithCommas(number) {
    if (typeof number === "undefined") return 'error'
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export {
    numberWithCommas
}
